<template>
  <div class="home">
    <Header />
    <ProviderRequests />
  </div>
</template>

<script>
import Header from "../Common/Header.vue";
import ProviderRequests from "@/components/Statistics/ProviderRequests.vue";

export default {
  name: "ProviderRequestsView",
  components: {
    Header,
    ProviderRequests
  }
};
</script>
